import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import styles from './Chart.module.css';
import { ChartFactory } from './core/ChartFactory';
import { mergeChartTheme } from './core/ChartTheme';
export function Chart({ config, library, className, 'data-testid': dataTestId }) {
    const adapter = useMemo(() => ChartFactory.createAdapter(library), [library]);
    const chartElement = useMemo(() => adapter.render(config), [adapter, config]);
    const theme = mergeChartTheme(config.theme);
    const chartKey = `${config.type}-${library}`;
    return (_jsx("div", { className: `${styles.container} ${className ?? ''}`, "data-testid": dataTestId ?? 'chart-container', style: {
            backgroundColor: theme.backgroundColor !== 'transparent' ? theme.backgroundColor : undefined,
        }, children: _jsx("div", { className: styles.chartWrapper, children: chartElement }) }, chartKey));
}
